import { Capacitor } from "@capacitor/core";
import { Browser } from "@capacitor/browser";

/**
 * Opens an external link in a native-safe way.
 * - Uses Capacitor's Browser plugin in native apps for http/https
 * - Uses Capacitor's App plugin for custom URL schemes
 * - Uses window.open in web/PWA
 * Returns a promise that resolves when the link is opened, or rejects if there's an error
 */
export const openExternalLink = async (url: string): Promise<void> => {
  try {
    console.log("Opening URL:", url);
    
    if (Capacitor.isNativePlatform()) {
      // Check if this is a special URL scheme (not http/https)
      if (url.startsWith("vnd.") || url.startsWith("intent:")) {
        // Use App plugin for custom URL schemes - in Capacitor v5+ it's just called openUrl
        await Browser.open({ url });
      } else {
        // Use Browser plugin for regular web URLs
        await Browser.open({ url });
      }
    } else {
      const newWindow = window.open(url, "_blank", "noopener,noreferrer");
      if (!newWindow) {
        throw new Error("Failed to open window");
      }
    }
  } catch (error) {
    console.error("Error opening external link:", error);
    throw error; // Re-throw to allow the caller to catch it
  }
};
